import BiddingZoneList from "../BiddingZoneList";
import BiddingZone from "../EuropeMap/BiddingZone";
import PriceLevels from "../PriceLevels/PriceLevels";

import css from "./CountryMap.module.css";

function CountryMap(props) {
  const biddingZoneList = BiddingZoneList();
  let viewBox = "";

  // Countries to match for this view (handles shared bidding zones)
  const matchCountries = props.matchCountries || [props.country];

  const mapData = biddingZoneList.map((zone) => {
    let price = null;

    if (matchCountries.includes(zone.country)) {
      viewBox = zone.viewBox;
      const averagePrice = props.zones.reduce((previous, cZone) => {
        if (zone.bz !== cZone.bz) {
          return previous;
        }
        const priceSum = cZone.data.reduce((previousPrice, data) => {
          return previousPrice + data.price;
        }, 0);
        return priceSum / cZone.data.length;
      }, []);
      if (props.zones.length > 0) {
        price = averagePrice;
      }
    }

    return (
      <BiddingZone
        key={`${zone.bz}-${zone.country}`}
        country={zone.country}
        d={zone.d}
        textX={zone.textX}
        textY={zone.textY}
        vat={props.vat}
        priceLevelVAT={props.vat}
      >
        {price}
      </BiddingZone>
    );
  });

  return (
    <>
      <div className={css.energyPriceLevels}>
        <PriceLevels vat={props.vat} />
      </div>
      <svg
        width="100%"
        version="1.0"
        viewBox={viewBox ? viewBox : "0 0 1190 1245"}
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
        className={css.map}
      >
        <g transform="translate(-50,1249) scale(0.1,-0.1)" stroke="none">
          {mapData}
        </g>
      </svg>
    </>
  );
}

export default CountryMap;
